import {
  Box,
  Paper,
  Typography,
  Grid,
  IconButton,
  InputAdornment,
  Tooltip,
  TextField,
  Button,
} from '@mui/material'
import { alpha } from '@mui/material/styles'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'
import React, { useCallback, useEffect, useState } from 'react'
import { MdAdd } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import { GiPayMoney } from 'react-icons/gi'
import { GrMoney } from 'react-icons/gr'
import { TbPigMoney } from 'react-icons/tb'
import { ModalContaAPagar } from './ModalContaAPagar'
import { FaSearch } from 'react-icons/fa'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import ModalContaAPagarConfirmacao from './ModalContaAPagarConfirmacao'
import PrimeTable from '../../../components/PrimeTable'

const ContasPagar = () => {
  const [modal, setModal] = useState(false)
  const [modalConfirmaPagamento, setModalConfirmaPagamento] = useState(false)
  const [habPesquisa, setHabPesquisa] = useState(false)
  const [reload, setReload] = useState(false)
  const [tela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [venceHoje, setVenceHoje] = useState(0.0)
  const [totalPagoHoje, setTotalPagoHoje] = useState(0.0)
  const [totalAVencer, setTotalAVencer] = useState(0.0)
  const [nrDocumento, setNrDocumento] = useState()
  const [dsMovimento, setDsMovimento] = useState()
  const [vlMovimento, setVlMovimento] = useState()
  const [idFormaPagamento, setIdFormaPagamento] = useState()
  const [idCategoria, setIdCategoria] = useState()
  const [dtEmissao, setDtEmissao] = useState()
  const [dtVencimento, setDtVencimento] = useState()

  const [ocultarValores, setOcultarValores] = useState(() => {
    try {
      return (
        localStorage.getItem('financeiro.contaPagar.ocultarValores') === 'true'
      )
    } catch {
      return false
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(
        'financeiro.contaPagar.ocultarValores',
        String(ocultarValores),
      )
    } catch {
      // Mantem o controle funcional quando o navegador bloqueia o storage.
    }
  }, [ocultarValores])

  const getIndicadores = useCallback(() => {
    metodoPrograma('getIndicadores', {}).then((res) => {
      if (res.status) {
        if (res.venceHoje) {
          setVenceHoje(res.venceHoje)
        }
        if (res.totalPagoHoje) {
          setTotalPagoHoje(res.totalPagoHoje)
        }
        if (res.totalAVencer) {
          setTotalAVencer(res.totalAVencer)
        }
      }
    })
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setModal(true)
  }

  const handleClickConfirmaPagamento = (linha) => {
    setDados(linha)
    setModalConfirmaPagamento(true)
  }

  const clica = () => {
    setDados(null)
    setModal(true)
  }

  const search = () => {
    setHabPesquisa((anterior) => !anterior)
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <>
            <Tooltip
              title={ocultarValores ? 'Mostrar valores' : 'Ocultar valores'}
            >
              <IconButton
                aria-label={
                  ocultarValores ? 'Mostrar valores' : 'Ocultar valores'
                }
                aria-pressed={ocultarValores}
                onClick={() => setOcultarValores((anterior) => !anterior)}
              >
                {ocultarValores ? (
                  <VisibilityOffOutlinedIcon />
                ) : (
                  <VisibilityOutlinedIcon />
                )}
              </IconButton>
            </Tooltip>
            <Tooltip title="Adicionar">
              <IconButton onClick={() => clica()}>
                <MdAdd />
              </IconButton>
            </Tooltip>
            <Tooltip title="Pesquisar">
              <IconButton onClick={() => search()}>
                <FaSearch />
              </IconButton>
            </Tooltip>
          </>,
        )
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela, ocultarValores])

  useEffect(() => {
    getIndicadores()
  }, [getIndicadores, modal])

  const handleClose = () => {
    setReload((v) => !v)
    setModal(false)
  }
  const handleCloseConfirmaPagamento = () => {
    setModalConfirmaPagamento(false)
    setReload((v) => !v)
  }

  const formatCurrency = (v) =>
    (v ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

  return (
    <Programa
      codigo="CtrlContaPagar"
      ferramentas={ferramentas}
      habTrocaLocal={false}
    >
      <ModalContaAPagar
        dados={dados}
        show={modal}
        handleClose={handleClose}
        setModal={setModal}
      />
      <ModalContaAPagarConfirmacao
        dados={dados}
        show={modalConfirmaPagamento}
        handleClose={handleCloseConfirmaPagamento}
        setModal={setModalConfirmaPagamento}
      />
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[
          {
            titulo: 'Vencendo hoje',
            valor: venceHoje,
            cor: '#ed8b23',
            Icone: TbPigMoney,
          },
          {
            titulo: 'Pagas hoje',
            valor: totalPagoHoje,
            cor: '#2e7d32',
            Icone: GiPayMoney,
          },
          {
            titulo: 'A vencer',
            valor: totalAVencer,
            cor: '#1976d2',
            Icone: GrMoney,
          },
        ].map(({ titulo, valor, cor, Icone }) => (
          <Grid item xs={12} sm={4} key={titulo}>
            <Paper
              elevation={0}
              sx={{
                px: { xs: 2, md: 2.5 },
                py: 1.5,
                height: '100%',
                boxSizing: 'border-box',
                borderRadius: 3,
                bgcolor: '#fff',
                border: '1px solid',
                borderColor: 'grey.200',
                borderTop: `3px solid ${cor}`,
                boxShadow: '0 3px 12px rgba(0, 0, 0, 0.06)',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 1,
                  mb: 0.75,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: '#616161', fontWeight: 500 }}
                >
                  {titulo}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 32,
                    height: 32,
                    flexShrink: 0,
                    borderRadius: 2,
                    bgcolor: alpha(cor, 0.1),
                    color: cor,
                  }}
                >
                  <Icone size={19} aria-hidden="true" />
                </Box>
              </Box>
              <Typography
                sx={{
                  fontSize: { xs: 24, sm: 22, md: 26 },
                  lineHeight: 1.2,
                  fontWeight: 700,
                  letterSpacing: '-0.5px',
                  fontVariantNumeric: 'tabular-nums',
                  overflowWrap: 'anywhere',
                  color: '#212121',
                }}
              >
                {ocultarValores ? '••••••' : formatCurrency(valor)}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
      {habPesquisa === true && (
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <TextField
              label="Nro Documento"
              value={nrDocumento}
              onChange={(e) => setNrDocumento(e.target.value)}
              fullWidth
              margin="dense"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Descrição"
              value={dsMovimento}
              onChange={(e) => setDsMovimento(e.target.value)}
              fullWidth
              margin="dense"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              label="Valor"
              fullWidth
              value={vlMovimento}
              onChange={(e) => setVlMovimento(e.target.value)}
              margin="dense"
              variant="outlined"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <AutoComplete
              InputLabelProps={{ shrink: true }}
              label="Forma de Pagamento"
              metodo="buscaFormaPagamento"
              value={idFormaPagamento}
              onChange={(_, v) => {
                setIdFormaPagamento(v?.[0]?.[0])
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <AutoComplete
              InputLabelProps={{ shrink: true }}
              label="Categoria"
              metodo="buscaCategoriaConta"
              value={idCategoria}
              onChange={(_, v) => {
                setIdCategoria(v?.[0]?.[0])
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              label="Emissão"
              value={dtEmissao}
              onChange={(e) => setDtEmissao(e.target.value)}
              fullWidth
              margin="dense"
              variant="outlined"
              type={'datetime-local'}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start"></InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              label="Vencimento"
              value={dtVencimento}
              onChange={(e) => setDtVencimento(e.target.value)}
              fullWidth
              margin="dense"
              variant="outlined"
              type={'datetime-local'}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start"></InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PrimeTable
            codigo="CtrlContaPagar"
            action="lista"
            rows={10}
            habSearch
            refresh={reload}
            head={[
              'Documento',
              'Descrição',
              'Empresa',
              'Categoria',
              'Forma',
              'Vencimento',
              'Valor',
              'Pago',
            ]}
            line={(item) => [
              item[5],
              item[7],
              item[3]?.[1],
              item[1]?.[1],
              item[2]?.[1],
              item[11],
              item[15],
              item[17],
            ]}
            columnOptions={[
              ...(ocultarValores
                ? [{ alias: 6, customJsx: () => <span>••••••</span> }]
                : []),
              {
                alias: 7,
                customJsx: ({ linhaOriginal }) =>
                  linhaOriginal[17] === null ? (
                    <Button
                      onClick={(event) => {
                        event.stopPropagation()
                        handleClickConfirmaPagamento(linhaOriginal)
                      }}
                      variant="outlined"
                      color="primary"
                      size="small"
                      style={{ margin: '5px' }}
                    >
                      Confirmar
                    </Button>
                  ) : ocultarValores ? (
                    '••••••'
                  ) : (
                    linhaOriginal[17]?.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                  ),
              },
            ]}
            collumnsDate={[5]}
            collumnsCurrency={[6]}
            parametros={{
              nrDocumento,
              dsMovimento,
              vlMovimento,
              idFormaPagamento,
              idCategoria,
              dtEmissao,
              dtVencimento,
            }}
            onRowSelect={handleClick}
          />
        </Grid>
      </Grid>
    </Programa>
  )
}

export default ContasPagar
